var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('lazy-image', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "icos"
  }, [_c('div', {
    staticClass: "audience-count"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.heatCount)))]), _vm._v(" "), _c('div', {
    staticClass: "praise-count"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.praiseCount)))]), _vm._v(" "), _c('div', {
    staticClass: "diamond-count"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.diamondCount)))])])]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('button', {
    staticClass: "subscribe-button",
    class: {
      disabled: _vm.isFollowed
    },
    on: {
      "click": _vm.subscribeHandler
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.isFollowed ? 'liveroom.unsubscribe' : 'liveroom.subscribe')))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };